import { render, staticRenderFns } from "./PortfolioNavigation.vue?vue&type=template&id=5b5ac44b&scoped=true"
import script from "./PortfolioNavigation.vue?vue&type=script&lang=ts"
export * from "./PortfolioNavigation.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioNavigation.vue?vue&type=style&index=0&id=5b5ac44b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ac44b",
  null
  
)

export default component.exports